import { useApiQuery } from "theSource/utils";
import { TotalCompensationStatementResponseDto } from "./types";
import { TOTAL_COMPENSATION_STATEMENT_QUERY_KEY } from "./utils";

export interface UseTotalCompensationStatementQueryProps {
  enabled: boolean;
  lifeEventId?: string;
}

export const useTotalCompensationStatementQuery = ({
  enabled,
}: UseTotalCompensationStatementQueryProps) => {
  const {
    data,
    isLoading,
    isFetching,
  } = useApiQuery<TotalCompensationStatementResponseDto>({
    queryKey: TOTAL_COMPENSATION_STATEMENT_QUERY_KEY,
    endpoint: `/subscriber/total_compensation`,
    showErrorSnackbar: false,
    enabled: enabled,
  });

  return {
    data,
    isLoading,
    isFetching,
  };
};